<div *ngIf="visible" class="permissions-banner">
    <div class="permissions-banner__content">
        <div class="permissions-banner__text">
            <div *ngIf="needsAnyPermission" class="permissions-banner__title">{{ 'Permissions.BannerTitle' | i18next }}</div>
        </div>

        <div *ngIf="needsAnyPermission" class="permissions-banner__actions">
            <dx-button
                *ngIf="showNotificationButton"
                stylingMode="text"
                [text]="'Permissions.EnableNotifications' | i18next"
                (onClick)="enableNotifications()">
            </dx-button>

            <dx-button
                *ngIf="showMicrophoneButton"
                stylingMode="text"
                [text]="'Permissions.EnableMicrophone' | i18next"
                (onClick)="enableMicrophone()">
            </dx-button>

            <dx-button
                *ngIf="showCameraButton"
                stylingMode="text"
                [text]="'Permissions.EnableCamera' | i18next"
                (onClick)="enableCamera()">
            </dx-button>
        </div>

        <button class="permissions-banner__close" type="button" (click)="dismiss()" [title]="'Permissions.DismissBanner' | i18next">
            &times;
        </button>
    </div>

    <div *ngIf="notificationsDenied || microphoneDenied || cameraDenied || microphoneNotFound || cameraNotFound" class="permissions-banner__warning">
        <span *ngIf="notificationsDenied">{{ 'Permissions.NotificationsDeniedHint' | i18next }}</span>
        <span *ngIf="microphoneDenied">{{ 'Permissions.MicrophoneDeniedHint' | i18next }}</span>
        <span *ngIf="microphoneNotFound && !microphoneDenied">{{ 'Permissions.MicrophoneNotFoundHint' | i18next }}</span>
        <span *ngIf="cameraDenied">{{ 'Permissions.CameraDeniedHint' | i18next }}</span>
        <span *ngIf="cameraNotFound && !cameraDenied">{{ 'Permissions.CameraNotFoundHint' | i18next }}</span>
    </div>

    <div *ngIf="showEdgeHint" class="permissions-banner__warning">
        <span>{{ 'Permissions.EdgeQuietHint' | i18next }}</span>
    </div>

    <div *ngIf="showSafariDockHint" class="permissions-banner__safari-hint">
        <span>{{ 'Permissions.SafariDockHint' | i18next }}</span>
    </div>
</div>
